module.exports = __webpack_public_path__ + "img/ding-tan1.7cb2a912.png";